import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { routeMapper, resultados, simuladorDeComissoes, orcamento } from 'src/app/utils/routeMapper';
import { pathToRegexp } from 'path-to-regexp';
import { filter } from 'rxjs/operators';
import { IntegracaoConstants } from 'src/app/constants/integracao';

@Component({
  selector: 'bread-crumbs',
  templateUrl: './bread-crumbs.component.html',
  styleUrls: ['./bread-crumbs.component.scss']
})
export class BreadCrumbsComponent implements OnInit {
  rotaAtual;
  breadcrumb = [];
  titulosFormulario = IntegracaoConstants.tituloFormulariosRamos;
  simuladorComissoes: boolean = false;
  @Input() draft;
  @Input() draftOriginal;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.initializeBreadCrumbs();
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => { this.initializeBreadCrumbs() });
  }

  initializeBreadCrumbs() {
    this.rotaAtual = this.router.routerState.snapshot.url;
    this.breadcrumb = this.getBreadCrumb();
    this.verificaIniciouSimuladorComissoes();
    if(this.verificaCotacaoNova()) this.removeBreadCrumb("Resultados");
    if(this.simuladorComissoes) this.setaSimuladorComissoesreadCrumb();
    this.setaParametrosURL();
  }

  setDraft(draft, draftOriginal) {
    this.draft = draft;
    this.draftOriginal = draftOriginal;
    this.initializeBreadCrumbs();
  }

  verificaCotacaoNova() {
    let draftAtualVazio = !this.draft?.idIntegracao || !this.draft?.versaoAtual;
    let draftOriginalVazio = !this.draftOriginal?.idIntegracao || !this.draftOriginal?.versaoAtual
    return draftAtualVazio && draftOriginalVazio && !this.verificaURL(this.rotaAtual, resultados) && !this.verificaURL(this.rotaAtual, orcamento);
  }

  verificaIniciouSimuladorComissoes() {
    if(!this.simuladorComissoes) this.simuladorComissoes = this.verificaURL(this.rotaAtual, simuladorDeComissoes);
    else this.simuladorComissoes = !this.verificaURL(this.rotaAtual, resultados);
  }

  getBreadCrumb() {
    const url = this.router.url;
    const breadcrumb = [];
    if (url !== '') {
      const routeInfo = routeMapper.find((info) => this.verificaURL(url, info.path));
      if (routeInfo) {
        for (const path of routeInfo.breadcrumb) {
          const parent = routeMapper.find((info) => this.verificaURL(path, info.path));
          breadcrumb.push({ path: parent.path, label: parent.label });
        }
        breadcrumb.push({ path: routeInfo.path, label: routeInfo.label });
      }
    }
    return breadcrumb.length > 1 ? breadcrumb : [];
  }

  verificaURL(urlAtual, padrao) {
    try {
      if(padrao.includes('?')) {
        if(urlAtual.includes('?')) {
          return padrao.split('?')[0] === urlAtual.split('?')[0];
        } else {
          return false;
        }
      } else {
        const regexPattern = pathToRegexp(padrao);
        const correspondem = regexPattern.test(urlAtual);
        return correspondem;
      }
    } catch (error) {
      return false;
    }
  }

  setaSimuladorComissoes() {
    this.simuladorComissoes = true;
    this.setaSimuladorComissoesreadCrumb();
  }

  removeBreadCrumb(itemLabel) {
    let index = this.breadcrumb.findIndex(u => u.label === itemLabel);
    if (index !== -1) this.breadcrumb.splice(index, 1);
  }

  setaParametrosURL() {
    this.breadcrumb.forEach((item) => {
      let router = item.path.split('/');
      let newUrl = '/';
      let newTitle = item.label;
      router.forEach((r, index, router) => {
        let parametros = this.activatedRoute.snapshot.params;
        if(Object.keys(parametros).length === 0) {
          parametros = this.activatedRoute.snapshot.queryParams;
        }
        if (r !== '') {
          if(r.includes('?')) {
            let primeiroSplit = r.split('?');
            newUrl = newUrl + primeiroSplit[0];
            newUrl = newUrl + location.search;
          } else {
            if (r && r.length > 0 && r[0] === ":") {
              let prop = r.split(":")[1];
              if(prop === "idIntegracao" && !parametros[prop]) prop = 'id';
              newUrl = index < router.length - 1 ? newUrl + parametros[prop] + '/' : newUrl + parametros[prop];
              if (newTitle === "Formulário" && prop === "ramo") {
                newTitle = newTitle + " " + this.titulosFormulario[parametros[prop]];
              }
            } else {
              newUrl = index < router.length - 1 ? newUrl + r + '/' : newUrl + r;
            }
          }
        }
      });
      item.path = newUrl;
      item.label = newTitle;
    });
  }

  setaSimuladorComissoesreadCrumb() {
    let index = this.breadcrumb.findIndex(u => u.label.includes('Formulário'));
    if(index !== -1) {
      let rota = routeMapper.find((info) => this.verificaURL(simuladorDeComissoes, info.path));
      if(rota) {
        this.breadcrumb[index].label = rota.label;
        this.breadcrumb[index].path = rota.path;
      }
    }
  }

  openPage(path) {
    this.router.navigateByUrl(path);
  }
}
